(function () {
  function isVisible(el) {
    if (!el) return false;
    const r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0 && window.getComputedStyle(el).visibility !== 'hidden';
  }

  function clickFirstVisible(selectors) {
    for (const sel of selectors) {
      const els = Array.from(document.querySelectorAll(sel));
      const el = els.find(isVisible);
      if (el) {
        el.click();
        return true;
      }
    }
    return false;
  }

  function openFlowSearchDropdown() {
    const dropdown =
      document.querySelector('search-dropdown.search-dropdown') ||
      document.querySelector('search-dropdown');

    // 1) If Flow component exists and has an open() method, use it
    if (dropdown) {
      try {
        if (typeof dropdown.open === 'function') {
          dropdown.open();
        } else {
          // 2) Manual open fallback (Flow-like)
          dropdown.setAttribute('aria-hidden', 'false');
          dropdown.classList.add('is-active', 'is-open', 'active');

          // overlay (Flow places it right after dropdown)
          const overlay = dropdown.nextElementSibling;
          if (overlay && overlay.classList && overlay.classList.contains('search-dropdown__overlay')) {
            overlay.classList.add('is-visible', 'active');
          }

          // body lock (common pattern)
          document.documentElement.classList.add('search-dropdown-open');
          document.body.classList.add('search-dropdown-open');
        }

        // focus input
        setTimeout(() => {
          const input = dropdown.querySelector('[data-predictive-search-input]');
          if (input) input.focus();
        }, 80);

        return true;
      } catch (e) {
        // keep going to header click fallback
      }
    }

    // 3) No dropdown found or failed -> click header search control (visible only)
    return clickFirstVisible([
      '[data-search-dropdown-open]',
      '[data-header-search]',
      '[data-search-open]',
      '[data-drawer-open="search"]',
      'button[aria-label*="search" i]',
      'a[aria-label*="search" i]',
      'button[aria-controls*="search" i]',
      'a[href="/search"]',
      'a[href^="/search?"]'
    ]);
  }

  function handler(e) {
    const trigger = e.target.closest('[data-open-search-dropdown]');
    if (!trigger) return;

     alert('search tap detected'); 
    // important on Android
    if (e.cancelable) e.preventDefault();

    // Sometimes dropdown gets injected late; try now + again shortly
    if (!openFlowSearchDropdown()) {
      setTimeout(openFlowSearchDropdown, 150);
      setTimeout(openFlowSearchDropdown, 400);
    }
  }

  // Android-friendly events
  document.addEventListener('pointerup', handler, true);
  document.addEventListener('touchend', handler, { capture: true, passive: false });
  document.addEventListener('click', handler, true);
})();
